import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACTS } from "./data";

const FAQS = [
  {
    q: "Quanto costa noleggiare una multifunzione?",
    a: "Dipende da volumi ed esigenze del tuo ufficio: il canone è mensile e include già toner, ricambi e assistenza. Scrivici su WhatsApp o chiamaci: il preventivo è gratuito e senza impegno.",
  },
  {
    q: "Cosa include il canone di noleggio?",
    a: "La multifunzione, l'installazione, la configurazione di rete, toner e consumabili, i ricambi e l'assistenza tecnica. Un unico canone, zero costi imprevisti.",
  },
  {
    q: "Cosa succede se la macchina si guasta?",
    a: "Interveniamo direttamente in sede entro 24 ore lavorative, con tecnici qualificati e ricambi a bordo. L'ufficio non si ferma.",
  },
  {
    q: "Posso richiedere solo l'assistenza, senza noleggio?",
    a: "Sì: assistiamo multifunzione Canon imageRUNNER e imageFORCE anche con interventi singoli o contratti di manutenzione programmata.",
  },
  {
    q: "Serve un anticipo o un investimento iniziale?",
    a: "No: con il noleggio operativo non c'è nessun esborso iniziale. Paghi solo il canone mensile.",
  },
  {
    q: "Posso passare a trovarvi in sede?",
    a: "Certo: siamo in Viale dell'Industria 3 a Paderno Dugnano (MI). Si prega di prendere appuntamento prima di passare: basta una telefonata o un messaggio WhatsApp.",
  },
  {
    q: "Vendete computer ai privati?",
    a: "Sì! La vendita di PC, periferiche e la riparazione computer sono aperte a tutti: aziende, professionisti e privati. Per il preventivo servono solo i tuoi dati di contatto; la Partita IVA è facoltativa e serve solo alle aziende.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 lg:py-40">
      <div className="px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C85A32] mb-4">Domande frequenti</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] text-[#181817] max-w-2xl">
            Le risposte che cerchi, senza giri di parole
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-16 max-w-3xl">
            {FAQS.map((f, i) => (
              <div key={f.q} className="border-b border-[#C5C2BA]">
                <button
                  data-testid={`faq-toggle-${i + 1}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center gap-6 py-6 text-left group"
                >
                  <span className="font-mono text-xs tracking-[0.2em] text-[#C85A32]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-display text-xl sm:text-2xl font-light text-[#181817]">{f.q}</span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="ml-auto shrink-0 text-[#6E6D69] group-hover:text-[#181817]"
                  >
                    <Plus size={18} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      data-testid={`faq-answer-${i + 1}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pl-12 pr-4 text-sm sm:text-base text-[#181817]/75 leading-relaxed max-w-xl">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
            <p className="mt-10 text-sm text-[#6E6D69]">
              Non trovi la risposta?{" "}
              <a
                data-testid="faq-whatsapp-link"
                href={CONTACTS.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C85A32] underline underline-offset-4 hover:text-[#181817] transition-colors duration-300"
              >
                Scrivici su WhatsApp
              </a>
              : rispondiamo in giornata.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
